// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import { get_lang_type } from '@/api/sysConfig'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    langList: [], // 动态语言类型列表（如 ['en', 'zh']）
    isLangListLoaded: false // 列表是否已加载完成
  },
  mutations: {
    // 更新语言类型列表
    setLangList(state, list) {
      state.langList = list
      state.isLangListLoaded = true
    }
  },
  actions: {
    // 从第三方服务器获取语言类型列表
    async fetchLangList({ commit }) {
      try {
        // 请求第三方的语言列表配置文件
        const res = await get_lang_type()
        const validLangs = []
        for (const item of res) {
          if (item.value && item.value.trim() !== '') {
            validLangs.push(item.value)
          }
        }
        commit('setLangList', validLangs)
        return validLangs
      } catch (error) {
        console.error('获取语言类型列表失败，使用默认列表', error)
        // 失败时使用默认列表（避免应用崩溃）
        const defaultLangs = ['en']
        commit('setLangList', defaultLangs)
        return defaultLangs
      }
    }
  }
})
